import React from 'react';

function HongKong(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124108)">
        <mask
          id="mask0_800_124108"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124108)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#EA1A1A"
          />
          <mask
            id="mask1_800_124108"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124108)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.8531 11.5748C17.8531 11.5748 11.3397 6.41151 19.1122 3.40314C19.1122 3.40314 21.3726 5.61975 19.6768 8.10822C19.1205 8.92438 18.6513 9.5072 18.2987 9.94518C17.5763 10.8425 17.3433 11.1319 17.8531 11.5748ZM8.24026 7.86752C7.79293 15.3924 15.9007 12.5221 15.9007 12.5221C15.2274 12.7294 15.0404 12.4147 14.4605 11.4395L14.4605 11.4395C14.1774 10.9633 13.8006 10.3296 13.2278 9.52232C11.4819 7.06136 8.24026 7.86752 8.24026 7.86752ZM20.5178 11.8271C20.5178 11.8271 28.8787 14.052 23.2717 19.7036C23.2717 19.7036 20.1675 18.5464 20.5178 15.654C20.6328 14.7056 20.78 14.0012 20.8907 13.4717L20.8907 13.4717C21.1175 12.3865 21.1906 12.0364 20.5178 11.8271ZM18.3203 13.5617C18.3203 13.5617 19.8191 21.204 11.6253 19.2727C11.6253 19.2727 11.4022 16.2873 14.4695 15.2728C15.4757 14.94 16.2505 14.742 16.8328 14.5933L16.8328 14.5933C18.0258 14.2885 18.4105 14.1902 18.3203 13.5617ZM28.6634 10.2753C23.5385 4.27314 19.433 11.1185 19.433 11.1185C19.7966 10.5737 20.168 10.7065 21.319 11.1182C21.8812 11.3193 22.6294 11.587 23.6535 11.8747C26.7742 12.7514 28.6634 10.2753 28.6634 10.2753Z"
              fill="white"
            />
            <path
              d="M11.1941 10.3422L11.6689 10.074C12.711 11.5319 14.0635 12.2492 15.7514 12.2492V12.7492C13.8631 12.7492 12.3357 11.9392 11.1941 10.3422Z"
              fill="#EA1A1A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.4688 10.75C24.9347 10.75 25.3125 10.4142 25.3125 10C25.3125 9.58579 24.9347 9.25 24.4688 9.25C24.0028 9.25 23.625 9.58579 23.625 10C23.625 10.4142 24.0028 10.75 24.4688 10.75Z"
              fill="#EA1A1A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.4534 15.7281C22.9194 15.7281 23.2971 15.3923 23.2971 14.9781C23.2971 14.5639 22.9194 14.2281 22.4534 14.2281C21.9874 14.2281 21.6096 14.5639 21.6096 14.9781C21.6096 15.3923 21.9874 15.7281 22.4534 15.7281Z"
              fill="#EA1A1A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.7034 17.7281C16.1694 17.7281 16.5471 17.3923 16.5471 16.9781C16.5471 16.5639 16.1694 16.2281 15.7034 16.2281C15.2374 16.2281 14.8596 16.5639 14.8596 16.9781C14.8596 17.3923 15.2374 17.7281 15.7034 17.7281Z"
              fill="#EA1A1A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.2034 10.7281C11.6694 10.7281 12.0471 10.3923 12.0471 9.97809C12.0471 9.56387 11.6694 9.22809 11.2034 9.22809C10.7374 9.22809 10.3596 9.56387 10.3596 9.97809C10.3596 10.3923 10.7374 10.7281 11.2034 10.7281Z"
              fill="#EA1A1A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.9534 7.72809C18.4194 7.72809 18.7971 7.3923 18.7971 6.97809C18.7971 6.56387 18.4194 6.22809 17.9534 6.22809C17.4874 6.22809 17.1096 6.56387 17.1096 6.97809C17.1096 7.3923 17.4874 7.72809 17.9534 7.72809Z"
              fill="#EA1A1A"
            />
            <path
              d="M17.5889 7.05276L18.0834 7.29103C17.1467 8.82702 17.0806 10.2438 17.8738 11.5698L17.3772 11.8045C16.4915 10.3239 16.5658 8.73042 17.5889 7.05276Z"
              fill="#EA1A1A"
            />
            <path
              d="M24.7668 9.68583L24.6825 10.1802C22.4823 9.88368 20.8353 10.2963 19.7076 11.4096L19.2895 11.075C20.5547 9.82604 22.3918 9.36579 24.7668 9.68583Z"
              fill="#EA1A1A"
            />
            <path
              d="M22.8952 15.3649L22.3438 15.4635C21.9047 13.5243 20.9052 12.2897 19.3426 11.7285L19.5533 11.2649C21.3064 11.8945 22.4213 13.2716 22.8952 15.3649Z"
              fill="#EA1A1A"
            />
            <path
              d="M15.6447 17.15L15.3518 16.7232C17.2518 15.6931 18.215 14.436 18.2739 12.9388L18.836 12.9563C18.77 14.636 17.6955 16.0382 15.6447 17.15Z"
              fill="#EA1A1A"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124108">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HongKong;
